import React from 'react';

interface SectionProps {
  id?: string;
  title?: string;
  subtitle?: string;
  children: React.ReactNode;
  className?: string;
  showDivider?: boolean;
}

export default function Section({
  id,
  title,
  subtitle,
  children,
  className = '',
  showDivider = true,
}: SectionProps) {
  return (
    <section
      id={id}
      className={`relative w-full ${showDivider ? 'border-t border-white/5' : ''} ${className}`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {(title || subtitle) && (
          <div className="mb-20 md:mb-28">
            {title && (
              <h2 className="text-white font-extrabold text-5xl md:text-6xl lg:text-7xl leading-[1.1] mb-6">
                {title}
              </h2>
            )}
            {subtitle && (
              <p className="text-white/70 text-lg md:text-xl max-w-3xl leading-relaxed">
                {subtitle}
              </p>
            )}
          </div>
        )}
        {children}
      </div>
    </section>
  );
}
